import styled from 'styled-components';

import { StyledControlBarButton } from '../../control-bar-button.styles';

export const StyledRemoveBookFromShelfButton = styled(StyledControlBarButton)`
  transform: translateY(3px);

  &:active {
    & rect {
      fill: ${({ theme }) =>
        theme.themeColors.controlBar.rightPanel.icons.bookshelfIcon
          .iconColorOnActive};
    }

    & line {
      stroke: ${({ theme }) =>
        theme.themeColors.controlBar.rightPanel.icons.bookshelfIcon
          .iconColorOnActive};
    }
  }
`;
